import React from 'react'
import { Button, DatePicker, Select, TextInput } from 'components/Form'
import { calculateApiRecord } from 'services/TransportProviderServicesService'
import { useDispatch, useSelector } from 'react-redux'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import dayjs from 'dayjs'
import {
    getTransportProviderData,
    getTransportProviderServiceData,
} from 'store/data/dataSlice'
import { productTypeOptions, serviceTypeOptions } from 'utils/options'
import { getData } from './store/dataSlice'
import { SimpleTable } from 'components/Ui'
injectReducer('claculator', reducer)

const validationSchema = Yup.object().shape({
    company: Yup.number().required('Please select company'),
    transport_provider: Yup.number().required(
        'Please select transport provider',
    ),
    service_name: Yup.array().required(
        'Please select tranport provider services',
    ),
    product_type: Yup.array().required('Product Type required'),
    date: Yup.date().required('Date is required'),
})

const TransportRateCalculator = () => {
    const dispatch = useDispatch()

    const { companyData, transportProviderData, transportProviderServiceData } =
        useSelector((state) => state.listData)
    const { view, data } = useSelector((state) => state.claculator.data)
    const [result, setResult] = React.useState()

    const handleSubmit = (values, setSubmitting) => {
        values.date = dayjs(values.date).format('YYYY-MM-DD')
        setSubmitting(true)
        calculateApiRecord(values)
            .then((response) => {
                setResult(response.data)
                setSubmitting(false)
            })
            .catch((error) => {
                setSubmitting(false)
                return error
            })
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Transport Rate Calculator
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-lg border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {'Calculator'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, touched, errors, isSubmitting }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                        <Field name="company">
                                            {({ field, form }) => (
                                                <Select
                                                    options={companyData}
                                                    label="Company"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="company"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.company &&
                                                        touched.company
                                                    }
                                                    message={errors.company}
                                                    value={values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                        form.setFieldValue(
                                                            'transport_provider',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'service_name',
                                                            [],
                                                        )
                                                        dispatch(
                                                            getTransportProviderData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                        dispatch(
                                                            getTransportProviderServiceData(
                                                                {
                                                                    company:
                                                                        e.target
                                                                            .value,
                                                                },
                                                            ),
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="transport_provider">
                                            {({ field, form }) => (
                                                <Select
                                                    options={transportProviderData?.filter(
                                                        (item) =>
                                                            item.type ===
                                                            'Aggregator',
                                                    )}
                                                    label="Transport Provider"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="transport_provider"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.transport_provider &&
                                                        touched.transport_provider
                                                    }
                                                    message={
                                                        errors.transport_provider
                                                    }
                                                    value={
                                                        values?.transport_provider
                                                    }
                                                    disabled={!values?.company}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="service_name">
                                            {({ field, form }) => (
                                                <Select
                                                    options={
                                                        transportProviderServiceData
                                                    }
                                                    label="Transport Provider Service"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="service_name"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.service_name &&
                                                        touched.service_name
                                                    }
                                                    message={
                                                        errors.service_name
                                                    }
                                                    value={values?.service_name}
                                                    disabled={!values?.company}
                                                    multiple
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            'product_type',
                                                            [],
                                                        )
                                                        form.setFieldValue(
                                                            'service_type',
                                                            [],
                                                        )
                                                        form.setFieldValue(
                                                            'from_zone',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'to_zone',
                                                            '',
                                                        )
                                                        dispatch(
                                                            getData({
                                                                assignment__service:
                                                                    e
                                                                        ? e[0]
                                                                        : '',
                                                            }),
                                                        )
                                                        form.setFieldValue(
                                                            field.name,
                                                            e,
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="date">
                                            {({ field, form }) => (
                                                <DatePicker
                                                    className="md:col-span-2"
                                                    label="Date"
                                                    name="date"
                                                    error={
                                                        errors.date &&
                                                        touched.date
                                                    }
                                                    message={errors.date}
                                                    value={
                                                        values?.date
                                                            ? dayjs(
                                                                  values?.date,
                                                              ).format(
                                                                  'YYYY-MM-DD',
                                                              )
                                                            : ''
                                                    }
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="from_zone">
                                            {({ field, form }) => (
                                                <Select
                                                    options={data?.from
                                                        ?.filter(
                                                            (item, index) =>
                                                                data?.from?.indexOf(
                                                                    item,
                                                                ) === index,
                                                        )
                                                        ?.map((item) => ({
                                                            label: item,
                                                            value: item,
                                                        }))}
                                                    label="From Zone"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="from_zone"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.from_zone &&
                                                        touched.from_zone
                                                    }
                                                    message={errors.from_zone}
                                                    value={values?.from_zone}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="to_zone">
                                            {({ field, form }) => (
                                                <Select
                                                    options={data?.to
                                                        ?.filter(
                                                            (item, index) =>
                                                                data?.to?.indexOf(
                                                                    item,
                                                                ) === index,
                                                        )
                                                        ?.map((item) => ({
                                                            label: item,
                                                            value: item,
                                                        }))}
                                                    label="To Zone"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="to_zone"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.to_zone &&
                                                        touched.to_zone
                                                    }
                                                    message={errors.to_zone}
                                                    value={values?.to_zone}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        {values?.service_name.map(
                                            (item, index) => {
                                                const service =
                                                    transportProviderServiceData?.find(
                                                        (service) =>
                                                            service.id.toString() ===
                                                            item,
                                                    )
                                                return (
                                                    <Field
                                                        key={item}
                                                        name="product_type"
                                                    >
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={
                                                                    productTypeOptions
                                                                }
                                                                label={`${service?.name} Product Type`}
                                                                size="sm"
                                                                placeholder="Select"
                                                                name="product_type"
                                                                className="md:col-span-2"
                                                                error={
                                                                    errors.product_type &&
                                                                    touched.product_type
                                                                }
                                                                message={
                                                                    errors.product_type
                                                                }
                                                                value={
                                                                    values
                                                                        ?.product_type[
                                                                        index
                                                                    ]
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    let arr = [
                                                                        ...values?.product_type,
                                                                    ]
                                                                    arr[index] =
                                                                        e.target.value
                                                                    form.setFieldValue(
                                                                        field.name,
                                                                        arr,
                                                                    )
                                                                }}
                                                            />
                                                        )}
                                                    </Field>
                                                )
                                            },
                                        )}
                                        {values?.service_name.map(
                                            (item, index) => {
                                                const service =
                                                    transportProviderServiceData?.find(
                                                        (service) =>
                                                            service.id.toString() ===
                                                            item,
                                                    )
                                                return (
                                                    <Field
                                                        key={`service-${item}`}
                                                        name="service_type"
                                                    >
                                                        {({ field, form }) => (
                                                            <Select
                                                                options={
                                                                    serviceTypeOptions
                                                                }
                                                                label={`${service?.name} Service Type`}
                                                                size="sm"
                                                                placeholder="Select"
                                                                name="service_type"
                                                                className="md:col-span-2"
                                                                error={
                                                                    errors.service_type &&
                                                                    touched.service_type
                                                                }
                                                                message={
                                                                    errors.service_type
                                                                }
                                                                value={
                                                                    values
                                                                        ?.service_type[
                                                                        index
                                                                    ]
                                                                }
                                                                onChange={(
                                                                    e,
                                                                ) => {
                                                                    let arr = [
                                                                        ...values?.service_type,
                                                                    ]
                                                                    arr[index] =
                                                                        e.target.value
                                                                    form.setFieldValue(
                                                                        field.name,
                                                                        arr,
                                                                    )
                                                                }}
                                                            />
                                                        )}
                                                    </Field>
                                                )
                                            },
                                        )}
                                        <Field name="quantity">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Quantity"
                                                    name="quantity"
                                                    error={
                                                        errors.quantity &&
                                                        touched.quantity
                                                    }
                                                    message={errors.quantity}
                                                    value={values?.quantity}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="weight">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Weight"
                                                    name="weight"
                                                    error={
                                                        errors.weight &&
                                                        touched.weight
                                                    }
                                                    message={errors.weight}
                                                    value={values?.weight}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="hours">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Hours"
                                                    name="hours"
                                                    error={
                                                        errors.hours &&
                                                        touched.hours
                                                    }
                                                    message={errors.hours}
                                                    value={values?.hours}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                        <Field name="cube">
                                            {({ field, form }) => (
                                                <TextInput
                                                    type="text"
                                                    className="md:col-span-2"
                                                    label="Cube"
                                                    name="cube"
                                                    error={
                                                        errors.cube &&
                                                        touched.cube
                                                    }
                                                    message={errors.cube}
                                                    value={values?.cube}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-center gap-4 mt-3">
                                        {/* <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button> */}
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            disabled={isSubmitting}
                                        >
                                            Calculate
                                        </Button>
                                    </div>
                                    {result?.service_results ? (
                                        Object.keys(
                                            result?.service_results,
                                        )?.map((key) => (
                                            <div
                                                key={key}
                                                className="mt-8 grid grid-cols-1 gap-x-4 gap-y-4"
                                            >
                                                <h3 className="font-medium text-black dark:text-white">
                                                    Service: {key}
                                                </h3>
                                                <SimpleTable>
                                                    <thead>
                                                        <SimpleTable.TR>
                                                            <SimpleTable.TH>
                                                                CPK Rate
                                                            </SimpleTable.TH>
                                                            <SimpleTable.TH>
                                                                Cubic
                                                            </SimpleTable.TH>
                                                            <SimpleTable.TH>
                                                                Minimum
                                                            </SimpleTable.TH>
                                                            <SimpleTable.TH>
                                                                Basic
                                                            </SimpleTable.TH>
                                                            <SimpleTable.TH>
                                                                Fuel levy
                                                            </SimpleTable.TH>
                                                            <SimpleTable.TH>
                                                                Fuel levy %
                                                            </SimpleTable.TH>
                                                            <SimpleTable.TH>
                                                                Charge
                                                            </SimpleTable.TH>
                                                        </SimpleTable.TR>
                                                    </thead>
                                                    <tbody>
                                                        {result
                                                            ?.service_results[
                                                            key
                                                        ]?.status ===
                                                        'Not Reconciled' ? (
                                                            <SimpleTable.TR>
                                                                <SimpleTable.TD
                                                                    colSpan="100%"
                                                                    className={`font-bold`}
                                                                >
                                                                    Not
                                                                    Reconciled
                                                                </SimpleTable.TD>
                                                            </SimpleTable.TR>
                                                        ) : (
                                                            <SimpleTable.TR>
                                                                <SimpleTable.TD>
                                                                    {
                                                                        result
                                                                            ?.service_results[
                                                                            key
                                                                        ]
                                                                            ?.cpk_rate
                                                                    }
                                                                </SimpleTable.TD>
                                                                <SimpleTable.TD>
                                                                    {
                                                                        result
                                                                            ?.service_results[
                                                                            key
                                                                        ]?.cubic
                                                                    }
                                                                </SimpleTable.TD>
                                                                <SimpleTable.TD>
                                                                    {
                                                                        result
                                                                            ?.service_results[
                                                                            key
                                                                        ]
                                                                            ?.minimum
                                                                    }
                                                                </SimpleTable.TD>
                                                                <SimpleTable.TD>
                                                                    {
                                                                        result
                                                                            ?.service_results[
                                                                            key
                                                                        ]?.basic
                                                                    }
                                                                </SimpleTable.TD>
                                                                <SimpleTable.TD>
                                                                    {
                                                                        result
                                                                            ?.service_results[
                                                                            key
                                                                        ]
                                                                            ?.calculated_fuel_levy
                                                                    }
                                                                </SimpleTable.TD>
                                                                <SimpleTable.TD>
                                                                    {
                                                                        result
                                                                            ?.service_results[
                                                                            key
                                                                        ]
                                                                            ?.fuel_levy_percentage
                                                                    }
                                                                </SimpleTable.TD>
                                                                <SimpleTable.TD
                                                                    className={`font-bold`}
                                                                >
                                                                    {
                                                                        result
                                                                            ?.service_results[
                                                                            key
                                                                        ]?.total
                                                                    }
                                                                </SimpleTable.TD>
                                                            </SimpleTable.TR>
                                                        )}
                                                    </tbody>
                                                </SimpleTable>
                                            </div>
                                        ))
                                    ) : result ? (
                                        <div className="mt-8 grid grid-cols-1 gap-x-4 gap-y-4">
                                            <h3 className="font-medium text-black dark:text-white">
                                                Service: {result?.service_name}
                                            </h3>
                                            <SimpleTable>
                                                <thead>
                                                    <SimpleTable.TR>
                                                        <SimpleTable.TH>
                                                            CPK Rate
                                                        </SimpleTable.TH>
                                                        <SimpleTable.TH>
                                                            Cubic
                                                        </SimpleTable.TH>
                                                        <SimpleTable.TH>
                                                            Minimum
                                                        </SimpleTable.TH>
                                                        <SimpleTable.TH>
                                                            Basic
                                                        </SimpleTable.TH>
                                                        <SimpleTable.TH>
                                                            Fuel levy
                                                        </SimpleTable.TH>
                                                        <SimpleTable.TH>
                                                            Fuel levy %
                                                        </SimpleTable.TH>
                                                        <SimpleTable.TH>
                                                            Charge
                                                        </SimpleTable.TH>
                                                    </SimpleTable.TR>
                                                </thead>
                                                <tbody>
                                                    {result?.status ===
                                                    'Not Reconciled' ? (
                                                        <SimpleTable.TR>
                                                            <SimpleTable.TD
                                                                colSpan="100%"
                                                                className={`font-bold`}
                                                            >
                                                                Not Reconciled
                                                            </SimpleTable.TD>
                                                        </SimpleTable.TR>
                                                    ) : (
                                                        <SimpleTable.TR>
                                                            <SimpleTable.TD>
                                                                {
                                                                    result?.cpk_rate
                                                                }
                                                            </SimpleTable.TD>
                                                            <SimpleTable.TD>
                                                                {result?.cubic}
                                                            </SimpleTable.TD>
                                                            <SimpleTable.TD>
                                                                {
                                                                    result?.minimum
                                                                }
                                                            </SimpleTable.TD>
                                                            <SimpleTable.TD>
                                                                {result?.basic}
                                                            </SimpleTable.TD>
                                                            <SimpleTable.TD>
                                                                {
                                                                    result?.calculated_fuel_levy
                                                                }
                                                            </SimpleTable.TD>
                                                            <SimpleTable.TD>
                                                                {
                                                                    result?.fuel_levy_percentage
                                                                }
                                                            </SimpleTable.TD>
                                                            <SimpleTable.TD
                                                                className={`font-bold`}
                                                            >
                                                                {result?.total}
                                                            </SimpleTable.TD>
                                                        </SimpleTable.TR>
                                                    )}
                                                </tbody>
                                            </SimpleTable>
                                        </div>
                                    ) : null}
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TransportRateCalculator
